import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from "./redux/store/index";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./bootstrap-overrides.css";
import './index.css';

const ReduxApp = () => (
  <Provider store={store}>
    <App />
  </Provider>
)

ReactDOM.render(<ReduxApp />, document.getElementById('root'));
